/* eslint-disable no-param-reassign */

export default (store) => ({
  addError(error) {
    store.errors.push(error);
  },

  clearErrors() {
    store.errors.splice(0, 1);
  },

  openConnectionModal() {
    store.displayConnectionModal = true;
  },

  closeConnectionModal() {
    store.displayConnectionModal = false;
  },

  openPendingTermsModal() {
    store.displayPendingTermsModal = true;
  },

  closePendingTermsModal() {
    store.displayPendingTermsModal = false;
  },

  setIsDiscountAllowed(value) {
    store.isDiscountAllowed = value;
  },

  setExperiment(experiment) {
    store.experiment = experiment;
  },

  setCreditsBalance(creditsBalance) {
    store.creditsBalance = creditsBalance;
  },

  setCurrentLiabilityTerms(term) {
    store.currentLiabilityTerms = term;
  },

  setCurrentPrivacyTerms(term) {
    store.currentPrivacyTerms = term;
  },

  setCurrentQuotePolicyStep(step) {
    store.currentQuotePolicyStep = step;
  },

  openOnboardingModal() {
    store.displayOnboardingModal = true;
  },

  closeOnboardingModal() {
    store.displayOnboardingModal = false;
  },

  setCurrentResolution382Terms(term) {
    store.currentResolution382Terms = term;
  },

  setCurrentJudicialNoRefundTerms(term) {
    store.currentJudicialNoRefundTerms = term;
  },
});
